import { handleApi } from '@/lib/api-handlers'

const TOKEN_KEY = 'fatigue_bid_token'
const USER_KEY = 'fatigue_bid_user'

export async function api(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' }
  const auth = token ?? localStorage.getItem(TOKEN_KEY)
  if (auth) headers.Authorization = `Bearer ${auth}`

  const result = await handleApi(path, { method, body, headers })
  if (result === null) {
    const err = new Error(`API 路由不存在: ${path}`)
    err.status = 404
    throw err
  }
  return result
}

export function persistSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function loadSession() {
  const token = localStorage.getItem(TOKEN_KEY)
  const raw = localStorage.getItem(USER_KEY)
  let user = null
  try {
    user = raw ? JSON.parse(raw) : null
  } catch {
    user = null
  }
  return { token, user }
}
